import { Loader } from '@calendly/ui/components/loader';
import classNames from 'classnames';

/** Single test id for chunk, settings, and list initial-load phases (SA-4159). */
const MEETINGS_TAB_LOADER_TEST_ID = 'meetings-tab-loader';

/**
 * Shared meetings-tab loader. Use `fill` for the unified initial-load shell
 * (Home chunk suspense, settings gate, and list fetch before chrome mounts).
 */
const loaderShellFillCss = "lnfyb9f";
const loaderShellCompactCss = "lhrl22g";
export const MeetingsTabLoader = ({
  fill = false,
  'data-testid': testId = MEETINGS_TAB_LOADER_TEST_ID
}) => <div className={classNames(fill ? loaderShellFillCss : loaderShellCompactCss)} aria-busy="true">
    <Loader data-testid={testId} />
  </div>;

require("./meetings_tab_loader.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./meetings_tab_loader.js");